import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCatchUp" */ './lazyIndex'),
    { name: 'CopilotCatchUp' }
);

// Components
export const LazyCopilotCatchUpButton = createLazyComponent(
    lazyModule,
    m => m.CopilotCatchUpButton
);
export const LazyCopilotCatchUpRollup = createLazyComponent(
    lazyModule,
    m => m.CopilotCatchUpRollup
);
export const LazyCopilotCatchUpNavigation = createLazyComponent(
    lazyModule,
    m => m.CopilotCatchUpNavigation
);
export const LazyCopilotCatchUpCard = createLazyComponent(lazyModule, m => m.CopilotCatchUpCard);

// Lazy Actions
export const lazyOnCopilotCatchUpButtonClickedMutator = new LazyAction(
    lazyModule,
    m => m.onCopilotCatchUpButtonClickedMutator
);

export const lazyGenerateCopilotCatchUp = new LazyAction(lazyModule, m => m.generateCopilotCatchUp);
